import { render, staticRenderFns } from "./web-ad-audienceEn.vue?vue&type=template&id=00992424&scoped=true&"
import script from "./web-ad-audienceEn.vue?vue&type=script&lang=js&"
export * from "./web-ad-audienceEn.vue?vue&type=script&lang=js&"
import style0 from "./web-ad-audienceEn.vue?vue&type=style&index=0&id=00992424&lang=scss&scoped=true&"
import style1 from "./web-ad-audienceEn.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00992424",
  null
  
)

export default component.exports